export const INSIGHTS_HEADLINE =
  'Auf einen Blick: Darauf kommt es in Deiner Bewerbung an';

export const INSIGHTS_TEXT_CONTENT =
  'In der Bewerbungswelt gibt es entscheidende Faktoren, die über Deinen Erfolg bestimmen. Hier findest Du noch einmal die wichtigsten Aspekte kurz und bündig für Dich zusammengefasst. Wir drücken Dir die Daumen!';

export const MAIN_INSIGHTS_TITLE = 'Deine Insights';

export const INSIGHTS_DATA = [
  'Individualisierte Bewerbungen sind entscheidend, um die Aufmerksamkeit der Personalabteilung zu gewinnen.',
  'Der Lebenslauf sollte gut strukturiert, auf das Wesentliche konzentriert und mit klaren Beweisen für Qualifikationen versehen sein.',
  'Im Anschreiben sollte eine spannende Einleitung, klare Botschaften und die Vermeidung von Füllwörtern beachtet werden.',
  'Bei vollständigen Bewerbungen sind passende Anhänge wie Zeugnisse und Zertifikate von hoher Qualität erforderlich.',
];
